import { Component, Input } from '@angular/core';
import { AppInsightsBlock, PlatformBlock } from '../_types/platform-health';

/// Pestaña "API": indicadores de API, las cuatro gráficas de la capa de API y las dos tablas de
/// Application Insights. Solo se muestra cuando el usuario tiene PLATFORM_HEALTH.INFRASTRUCTURE (el
/// padre decide eso con el *ngIf del p-tabPanel), así que este componente no vuelve a comprobar el
/// permiso. Componente de presentación puro: no pide datos, no construye gráficas, no conoce el
/// servicio.
@Component({
    selector: 'app-platform-health-api',
    templateUrl: './platform-health-api.component.html',
    styleUrls: ['./platform-health-api.component.scss'],
    standalone: false
})
export class PlatformHealthApiComponent {
    @Input() public platform: PlatformBlock | null = null;
    @Input() public appInsights: AppInsightsBlock | null = null;

    @Input() public trafficChart: any = null;
    @Input() public latencyChart: any = null;
    @Input() public appServiceChart: any = null;
    @Input() public threadsChart: any = null;

    @Input() public chartOptions: any = null;
    @Input() public trafficChartOptions: any = null;
    @Input() public appServiceChartOptions: any = null;
}
